import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Rules from "./components/Rules";
import Gallery from "./components/Gallery";
import Roadmap from "./components/Roadmap";
import Founder from "./components/Founder";
import Follow from "./components/Follow";
import Connect from "./components/Connect";
import Footer from "./components/Footer";
import Mint from "./contract/mint";
import Whitepaper from "./components/Whitepaper";

function Main() {
  return (
    <div>
      <Navbar></Navbar>
      <div className="content">
        <Hero></Hero>
        <About></About>
        <Rules></Rules>
        <Mint></Mint>
        <Gallery></Gallery>
        <Roadmap></Roadmap>
        <Founder></Founder>
        <Whitepaper></Whitepaper>
        <Follow></Follow>
        {/* <Connect></Connect> */}
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Main;
